/**
 * @description 合并 displayName 为 Other 的机器类型
 */

/**
 * 合并机器类型列表中 displayName 为 Other 的机型
 * 所有 displayName 为 Other 的机型都会使用统一的 robotFamilyCode
 * @param {Array} robotTypeList 原始机器类型列表
 * @param {string} otherCode 合并后的 robotFamilyCode，默认为 "111"
 * @returns {Array} 处理后的机器类型列表
 * write by cursor
 */


// 存在的问题：合并其他机型到111， 可能存在显示属性 与 111 不一致的情况: x 支持 ota， 合并为111， 111不支持ota.

export const DEAULT_OTHER_CODE = '111';

export const OTHER_DISPLAY_NAME = 'Other';

// 来自dm的机器类型接口，一定有 robotFamilyCode， 如果没有，则源数据源有问题。
export default function mergeOtherRobotTypes(robotTypeList = [], otherCode = DEAULT_OTHER_CODE) {
  if (!robotTypeList || !Array.isArray(robotTypeList) || robotTypeList.length === 0) {
    return robotTypeList;
  }

  // 找出所有 displayName 为 Other 的机型
  const otherTypes = robotTypeList.filter(item => item.displayName === OTHER_DISPLAY_NAME);
  
  // 如果没有 Other 类型，直接返回原列表
  if (otherTypes.length === 0) {
    return robotTypeList;
  }

  // 找出非 Other 类型的机型
  const normalTypes = robotTypeList.filter(item => item.displayName !== OTHER_DISPLAY_NAME);
  
  // 优先使用 robotFamilyCode 等于 otherCode 的 Other 类型作为基础
  const baseOtherType = otherTypes.find(item => item.robotFamilyCode === otherCode) || otherTypes[0];
  
  // 创建合并后的 Other 类型
  const mergedOtherType = {
    ...baseOtherType,
    robotFamilyCode: otherCode, // 确保使用统一的 robotFamilyCode
    displayName: OTHER_DISPLAY_NAME,
  };

  // 返回合并后的列表
  return [...normalTypes, mergedOtherType];
}

// robotTypeList 原始的 robotFamilyCode 和 displayName 的 映射 Map结构
export const getOriginalRobotTypeMap = (robotTypeList = []) => {
  return robotTypeList.reduce((acc, item) => {
    acc[item.robotFamilyCode] = item.displayName;
    return acc;
  }, {});
};

// 合并 OTHER_DISPLAY_NAME 后的 robotTypeList 的 映射map 结构
export const getMergedRobotTypeMap = (robotTypeList = []) => {
  return mergeOtherRobotTypes(robotTypeList).reduce((acc, item) => {
    acc[item.robotFamilyCode] = item.displayName;
    return acc;
  }, {});
};